export default [
  {
    question: 'Who is my Account Director?',
    answer: [
      "If you're unsure who your Account Director is, or you don't have their contact details, please email enquiries@neosnetworks.com who will be able to provide you with this information.",
    ],
  },
];
